<div class="contents">
  <app-back-button></app-back-button>
  <div class="add-container">
    <div class="add-content">
      <h3>Cadastro de representante</h3>
      <p *ngIf="profileEducationalInstitution">Efectue o cadastro dos representantes da
        {{profileEducationalInstitution.nome}} (<b>{{profileEducationalInstitution.sigla}}</b>)</p>

      <form [formGroup]="representacaoForm" (ngSubmit)="onSubmit()" class="add-represent-form">
        <div class="p-fluid grid">
          <div class="field col-12">
            <div class="new-represent">
              <div class="modal-header" style="margin-bottom: 5px !important;">
                <div class="icon">
                  <img src="icons/plus-circle.svg" alt="Email Icon" />
                </div>
                <span class="title">Novo representante</span>
              </div>
            </div>
          </div>
          <div class="field col-12">
            <div class="file-upload">
              <p-fileupload name="myfile[]" (onSelect)="onSelectedFiles($event)" [multiple]="false"
                accept="image/png, image/jpeg, image/jpg" maxFileSize="2000000000"
                invalidFileTypeMessageSummary="danger" invalidFileTypeMessageDetail="O Ficheiro seleccionado é inválido"
                invalidFileLimitMessageSummary="danger" invalidFileLimitMessageDetail="Ficheiro muito grande. Min: 2MB">
                <ng-template #header let-files let-chooseCallback="chooseCallback" let-clearCallback="clearCallback"
                  let-uploadCallback="uploadCallback">
                </ng-template>
                <ng-template #content let-files let-uploadedFiles="uploadedFiles"
                  let-removeFileCallback="removeFileCallback" let-chooseCallback="chooseCallback"
                  let-removeUploadedFileCallback="removeUploadedFileCallback">
                  <a class="circular-upload preview"
                    [ngStyle]="{ 'background-image': imagePreview ? 'url(' + imagePreview + ')' : 'none' }">
                    <span *ngIf="!imagePreview">Foto</span>
                    <div class="icon" (click)="choose($event, chooseCallback)">
                      <img src="icons/camera-01.svg" alt="">
                    </div>
                  </a>
                </ng-template>
                <ng-template #file></ng-template>
                <ng-template #empty></ng-template>
              </p-fileupload>
            </div>
          </div>

          <div class="field col-6">
            <label for="nacionalidade">Nacionalidade</label>
            <p-select [filter]="true" appendTo="body" id="nacionalidade" class="w-full" optionLabel="designacao"
              optionValue="id" [options]="nacionalidades" formControlName="NacionalidadeEnum"
              placeholder="Seleccione a nacionalidade" />
            <div
              *ngIf="representacaoForm.get('NacionalidadeEnum')?.touched && representacaoForm.get('NacionalidadeEnum')?.invalid">
              <small class="error-message"
                *ngIf="representacaoForm.get('NacionalidadeEnum')?.errors?.['required']">Número
                Nacionalidade é obrigatório.</small>
            </div>
          </div>

          <div class="field col-6">
            <label for="bi">Número de Identificação</label>
            <div class="flex align-items-center relative w-100">
              <input id="bi" type="text" class="w-full pr-4" pInputText formControlName="bi"
                placeholder="Informe o número do bilhete de identidade" />
              <button pButton *ngIf="isInternalInstitution" [disabled]="f.bi?.invalid" type="button" icon="pi pi-search"
                class="search-btn" (click)="searchDocumentNumber()" aria-label="Search"></button>
            </div>
          </div>
          <div class="field col-6">
            <label for="nome">Nome</label>
            <input id="nome" type="text" class="w-full" pInputText formControlName="nome" placeholder="Digite o nome" />
            <div *ngIf="f.nome?.invalid && f.nome?.touched" class="error error-message">
              Nome é obrigatório
            </div>
          </div>

          <div class="field col-6 d-flex flex-column">
            <label for="contacto">Telefone</label>
            <ng-container *ngIf="isInternalInstitution; else foreignPhone" class="w-full col-6">
              <p-inputmask class="w-full d-grid" id="telemovelRequerente" mask="+244 999 999 999" formControlName="telefone"
                placeholder="+244 999 999 000" />
            </ng-container>
            <ng-template #foreignPhone>
              <input id="contacto" type="number" class="w-full d-grid" pInputText formControlName="telefone"
                placeholder="Digite o telefone com código do país" />
            </ng-template>
            <div *ngIf="f.telefone?.invalid && f.telefone?.touched" class="error error-message">
              Telefone é obrigatório e deve conter apenas números
            </div>
          </div>

          <div class="field col-6">
            <label for="email">Email</label>
            <input id="email" type="email" class="w-full" pInputText formControlName="emailRepresentante"
              placeholder="Digite o email" />
            <div *ngIf="f.emailRepresentante?.invalid && f.emailRepresentante?.touched" class="error error-message">
              Email é obrigatório e deve ser válido
            </div>
          </div>

          <div class="field col-6">
            <label for="typeRepre">Tipo de Representação</label>
            <p-select [filter]="true" appendTo="body" id="tipoRepresentacao" class="w-full" optionLabel="designacao"
              optionValue="id" [options]="tiposRepresentacao" placeholder="Seleccione o tipo de representação"
              formControlName="tipoRepresentacaoInstituicaoEnsinoID" />
            <div
              *ngIf="f.tipoRepresentacaoInstituicaoEnsinoID?.invalid && f.tipoRepresentacaoInstituicaoEnsinoID?.touched"
              class=" error-message">
              Tipo de representação é obrigatório
            </div>
          </div>

        </div>
        <div class="modal-footer" style="margin-top: -10px !important; ">
          <p-button type="submit" [label]="editIndex != null ? 'Editar Representante' : 'Adicionar Representante'"
            class="p-button-primary"></p-button>
        </div>
      </form>
    </div>
  </div>

  <div class="representantes-list list">
    <ng-container *ngIf="representantes.length > 0; else noRepresentantes">
      <app-representante-card *ngFor="let representante of representantes; let i = index"
        [instituicaoEnsino]="profileEducationalInstitution" [representante]="representante"
        (delete)="deleteRepresentante($event, i)" (edit)="editRepresentante($event, i)">
      </app-representante-card>
    </ng-container>
    <ng-template #noRepresentantes>
      <p class="empty-message d-flex align-items-center justify-content-center w-100">Não há representantes cadastrados.
      </p>
    </ng-template>
  </div>

  <div class="modal-footer" style="margin-top: 5px !important; padding: 1rem 1rem 2rem 0rem;">
    <p-button [disabled]="representantes.length <= 0 || isLoading" type="submit" class="p-button-primary"
      (click)="save(representantes)">
      <ng-container *ngIf="isLoading; else saveLabel">
        <i class="pi pi-spin pi-spinner"></i> Guardando...
      </ng-container>
      <ng-template #saveLabel>Guardar Representante</ng-template>
    </p-button>
  </div>
</div>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>